import { Code } from './models/code';
import Service from './Service';

class CodeService {
  private static URL_BASE = process.env.REACT_APP_URL_API;

  static create(data: {
    lockId: number;
    startDate?: string | null;
    duration: number;
    durationUnit: 'hours' | 'days';
  }): Promise<Code> {
    return Service.post(`${this.URL_BASE}/codes`, data);
  }

  static findAllByStationId(
    stationId: number,
    status?: 'active' | 'scheduled' | 'expired',
    limit?: number,
    offset?: number,
  ): Promise<{ codes: Code[]; total: number }> {
    const params = new URLSearchParams();
    if (status) params.set('status', status);
    if (limit !== undefined) params.set('limit', String(limit));
    if (offset !== undefined) params.set('offset', String(offset));
    const query = params.toString();
    return Service.get(`${this.URL_BASE}/codes/station/${stationId}${query ? `?${query}` : ''}`);
  }

  static findActiveByLockId(lockId: number): Promise<{ codes: Code[] }> {
    return Service.get(`${this.URL_BASE}/codes/lock/${lockId}`);
  }

  static revoke(id: number): Promise<{ success: boolean }> {
    return Service.patch(`${this.URL_BASE}/codes/${id}/revoke`, {});
  }

  static revokeAllByStationId(stationId: number): Promise<{ success: boolean }> {
    return Service.post(`${this.URL_BASE}/codes/station/${stationId}/revoke-all`);
  }

  static generateMultiple(
    stationId: number,
    data: {
      lockIds: number[];
      startDate?: string | null;
      duration: number;
      durationUnit: 'hours' | 'days';
    },
  ): Promise<{ codes: Code[] }> {
    return Service.post(`${this.URL_BASE}/codes/station/${stationId}/generate-multiple`, data);
  }
}

export default CodeService;
